<template>
  <el-row :gutter="10">
    <el-col :span="10">
      <el-card shadow="never" style="height: calc( 100vh - 134px);overflow: auto;">
        <div slot="header">
          <span>角色</span>
        </div>
        <role @current-change="roleChange"></role>
      </el-card>
    </el-col>
    <el-col :span="14">
      <el-card shadow="never" style="height: calc(100vh - 134px);overflow: auto;">
        <div slot="header">
          <span>功能</span>
          <el-divider direction="vertical"></el-divider>
          <span>{{ currentRole.name }}({{ checkedAuth.length }})</span>
          <el-button v-show="showSaveBtn" style="float: right; padding: 3px 0" @click="setRoleAuthorities" type="text">
            保存角色功能
          </el-button>
        </div>
        <authorities ref="authorities" v-loading="authLoading" @check="authorityCheckChange" ></authorities>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
  import Role from "./Role";
  import Authorities from "./Authorities";
  import {getRoleAuthorities, setRoleAuthorities} from "@/api/remote";

  export default {
    name: "Authority",
    components: {Authorities, Role},
    data() {
      return {
        currentRole: {
          name: null,
          code: null,
        },
        checkedAuth: [],
        authLoading: false,
        showSaveBtn: false,
      }
    },
    methods: {
      roleChange(role) {
        if (this.showSaveBtn) {
          this.$confirm(`${this.currentRole.name}权限已变更，是否保存?`).then(() => {

          }).finally(() => {
            this.setRole(role)
          })
        } else {
          this.setRole(role)
        }
      },
      setRole(role) {
        this.currentRole = role;
        this.getRoleAuthorities(role.code);
        this.showSaveBtn = false;
      },
      authorityCheckChange(data, checked) {
        if (this.currentRole.code) {
          this.showSaveBtn = true;
          this.checkedAuth = checked.checkedKeys;
        } else {
          this.$message.warning("请选择角色")
        }
      },
      getRoleAuthorities(code) {
        this.authLoading = true;
        getRoleAuthorities({code: code}).then(res => {
          this.checkedAuth = res.data;
          this.$refs.authorities.setCheckedKeys(res.data);
          this.authLoading = false;
        }, () => this.authLoading = false)
      },
      setRoleAuthorities() {
        setRoleAuthorities({code: this.currentRole.code, authoritiesCode: this.checkedAuth}).then(res => {
          this.$message.success("保存成功");
          this.showSaveBtn = false;
        })
      }
    }
  }
</script>

<style scoped>

</style>
